
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[type]/page/[...page]",
      function () {
        return require("private-next-pages/[type]/page/[...page].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[type]/page/[...page]"])
      });
    }
  